export default {
    props:["text"],
    computed: {
        hasSlot() {
            return Object.keys(this.$slots).length
        }
    }
}